import { render, staticRenderFns } from "./SjGoods.vue?vue&type=template&id=76fdf06e&scoped=true"
import script from "./SjGoods.vue?vue&type=script&lang=js"
export * from "./SjGoods.vue?vue&type=script&lang=js"
import style0 from "./SjGoods.vue?vue&type=style&index=0&id=76fdf06e&prod&lang=css"
import style1 from "./SjGoods.vue?vue&type=style&index=1&id=76fdf06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fdf06e",
  null
  
)

export default component.exports